// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"ToggleSwitch_toggle-switch__1wDmb"};